<b3-modal
  #rejectConfirmModal
  [open]="open"
  overlay
  size="md"
  (b3-close)="onModalDismiss()">
  <b3-modal-header
    [heading]="heading"
    aria-level="2"
    icon="error"
    icon-tone="danger"
    close-aria-label="Fechar">
  </b3-modal-header>

  <b3-modal-body>
    <p class="project-validation-reject-confirm-modal__text">
      {{ message }}
    </p>
  </b3-modal-body>

  <b3-modal-footer>
    <div class="project-validation-reject-confirm-modal__footer">
      <b3-button
        type="button"
        variant="outlined"
        tone="default"
        (b3-click)="onCancel()">
        Cancelar
      </b3-button>
      <b3-button
        type="button"
        variant="filled"
        tone="danger"
        (b3-click)="onConfirm()">
        <b3-icon name="check_circle" size="md" tone="on-brand"></b3-icon>
        Confirmar
      </b3-button>
    </div>
  </b3-modal-footer>
</b3-modal>
